import { __read } from "tslib";
import React from 'react';
import { pluginKey as widthPluginKey } from '../../plugins/width';
import { WidthConsumer } from '@atlaskit/editor-common';
import { ContextPanelConsumer, } from '../ContextPanel/context';
function useCreateWidthCallbacks(_a) {
    var setContextPanelWidth = _a.setContextPanelWidth, setContainerWidth = _a.setContainerWidth;
    var contextPanelWidthCallback = React.useCallback(function (_a) {
        var width = _a.width;
        setContextPanelWidth(width);
        return null;
    }, [setContextPanelWidth]);
    var containerWidthCallback = React.useCallback(function (_a) {
        var width = _a.width;
        setContainerWidth(width);
        return null;
    }, [setContainerWidth]);
    return [contextPanelWidthCallback, containerWidthCallback];
}
var WidthEmitter = function (_a) {
    var editorView = _a.editorView;
    var _b = __read(React.useState(0), 2), contextPanelWidth = _b[0], setContextPanelWidth = _b[1];
    var _c = __read(React.useState(0), 2), containerWidth = _c[0], setContainerWidth = _c[1];
    var _d = __read(useCreateWidthCallbacks({ setContextPanelWidth: setContextPanelWidth, setContainerWidth: setContainerWidth }), 2), contextPanelWidthCallback = _d[0], containerWidthCallback = _d[1];
    React.useEffect(function () {
        var width = containerWidth - contextPanelWidth;
        if (width <= 0 || isNaN(width) || !editorView) {
            return;
        }
        var dom = editorView.dom, tr = editorView.state.tr, dispatch = editorView.dispatch;
        tr.setMeta(widthPluginKey, {
            width: width,
            lineLength: dom ? dom.clientWidth : undefined,
        });
        dispatch(tr);
        return function () { };
    }, [editorView, contextPanelWidth, containerWidth]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ContextPanelConsumer, null, contextPanelWidthCallback),
        React.createElement(WidthConsumer, null, containerWidthCallback)));
};
export default WidthEmitter;
//# sourceMappingURL=index.js.map